import React, {Component} from 'react';
import {Breadcrumb, Form, Grid, List, Message, Header, Modal, Button} from 'semantic-ui-react';
import {Link, withRouter} from 'react-router-dom';
import {Helmet} from "react-helmet";
import {connect} from "react-redux";
import CustomDivider from '../../components/extras/CustomDivider';
import Loading from "../../components/extras/Loading";
import IngredientData from "../../data/IngredientData";
import ProductData from "../../data/ProductData";
import ShoppingListItem from "../../components/inventories/ShoppingListItem";
import ShoppingItem from "../../components/inventories/ShoppingItem";
import localDB from "../../data/localDB";
import helpers from "../../functions/helpers";
import {showToast} from "../../actions/ToastAction";
import {providerDialog} from "../../actions/ProviderDialogAction";
import {selectProvider} from "../../actions/ProviderSelectAction";
import ProviderDialog from "../../components/contacts/ProviderDialog";
import NotificationsData from "../../data/NotificationsData";
const C = require("../../constants");

class ShoppingList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data:[],
            shopping_list:[],
            providers: [],
            options: [],
            comments: '',
            loading: true,
            open_modal_send: false,
            selected_channel: 'whatsapp',
            selected_provider: null
        };

        this.handleSearchProvider = this.handleSearchProvider.bind(this)
    }

    componentDidMount() {
        this.loadData()
    }

    loadData = () => {
        this.setState({loading: true});
        Promise.all([
            IngredientData.shoppingList(),
            ProductData.shoppingList()
        ]).then(([ingredients, products]) => {
            ingredients = ingredients.map(ingredient => {
                ingredient['type'] = 'ingredient'
                return ingredient
            })

            products = products.map(product => {
                product['type'] = 'product'
                return product
            })

            this.setState({'data': products.concat(ingredients), 'loading':false})
        });
    };

    itemList = (item) => {
        return <ShoppingItem {...item} key={item.id} callbackClick={this.addItemList}/>
    }

    itemShoppingList = (item) => {
        return <ShoppingListItem {...item} key={item.id} callbackClick={this.actionsItemShoppingList}/>
    }

    openModalSend = () => {
        if(this.state.shopping_list.length > 0){
            this.setState({open_modal_send: true})
        }else{
            this.props.showToast({
                message: 'Agrega algunas cosas a tu lista de compras!',
                type: 'error'
            });
        }
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.provider_select && nextProps.provider_select.id) {
            this.handleProviderChange(nextProps.provider_select.id);
            this.setState({providers: helpers.mapProviders([nextProps.provider_select])})
        }
    };

    handleSearchProvider = (e, value) => {
        localDB.findProviders(value.searchQuery).then(data => {
            this.setState({providers: helpers.mapProviders(data)});
        })
    };

    handleProviderChange = (result) => {
        localDB.findProviders(result).then(data => {
            if(data[0]){
                this.setState({selected_provider: data[0]});
            }
        })
    };

    sendWhatsappMessage = () => {
        let message = `*🛒 Lista de Compras*%0a%0a`
        this.state.shopping_list.forEach(item => {
            message += `✅ *${item.quantity}x* ${item.name}${item.observations ? `%0a️_${item.observations}_`:''}%0a%0a`
        })
        message += this.state.comments ? `*🗒 Comentarios*%0a_${this.state.comments}_`:''
        window.open(`https://wa.me/${this.state.selected_provider.phone_prefix}${this.state.selected_provider.phone}?text=${message}`);
    }

    sendEmail = () => {
        this.setState({sending: true});
        NotificationsData.add({shopping_list:this.state.shopping_list, comments: this.state.comments, email:this.state.selected_provider.email}, (res) => {
            if (res !== null && res.send) {
                this.props.showToast({message: 'Lista de compras enviada!', type: 'success'});
                this.cleanShoppingList();
            } else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
            }
            this.setState({sending: false});
        });
    }

    addItemList = (item) => {
        let shopping_list = this.state.shopping_list
        item = this.state.data.find(ele => ele.id===item.id && ele.type===item.type)
        if(item && !this.state.shopping_list.find(ele => ele.id === item.id)){
            item['quantity'] = 1
            item['observations'] = ''
            shopping_list.push({name: item.name, quantity: 1, observations:'', id:item.id})
            let data = this.state.data.filter(d => d.id !== item.id)
            this.setState({data, shopping_list})
        }
    }

    actionsItemShoppingList = (data) => {
        let shopping_list = this.state.shopping_list;
        if(data.action === 'delete'){
            shopping_list = this.state.shopping_list.filter(d => d.id !== data.id)
            this.setState({shopping_list})
        }
        if(data.action === 'quantity'){
            shopping_list.find(d => d.id === data.id)
            this.setState({shopping_list})
            shopping_list.find( function (d) {
                if (d.id !== data.id) return false;
                d.quantity = data.quantity
                return true;
            } );
        }
        if(data.action === 'observations'){
            shopping_list.find(d => d.id === data.id)
            this.setState({shopping_list})
            shopping_list.find( function (d) {
                if (d.id !== data.id) return false;
                d.observations = data.observations
                return true;
            } );
        }
    }

    handleSearchItem = async(e, value) => {
        let data = await localDB.findShoppingList(value.searchQuery)
        this.setState({options: helpers.mapShoppingList(data)});
    };

    editProvider = () => {
        let provider = this.state.selected_provider
        this.props.selectProvider(provider);
        this.props.providerDialog({open:true, provider});
    };

    handleSearchChange = (result) => {
        let item = this.state.options.find(option => option.key === result)
        if(item && !this.state.shopping_list.find(ele => ele.id === result)){
            let shopping_list = this.state.shopping_list
            shopping_list.push({name: item.text, quantity: 1, observations:'', id:item.key})
            this.setState({shopping_list})
        }
    };

    handleCommentsChange = (event) => {
        this.setState({comments:event.target.value});
    };

    handleAddProvider = (e, {value}) => {
        this.props.providerDialog({
            open: true,
            provider: {id: null, full_name: value, provider: null, factory: '', email: '', phone: '',  phone_prefix: '+57'}
        });
    };

    handleSendMessage = () => {
        let phone_channels = ['whatsapp', 'telegram']
        if(!this.state.selected_provider){
            this.props.showToast({
                message: 'Selecciona un contácto!',
                type: 'error'
            });
        }else if(this.state.selected_channel === 'email' && !this.state.selected_provider.email){
            this.props.showToast({
                message: 'El contácto no tiene email!',
                type: 'error'
            });
        }else if(phone_channels.includes(this.state.selected_channel) && !this.state.selected_provider.phone){
            this.props.showToast({
                message: 'El contácto no tiene un número de teléfono!',
                type: 'error'
            });
        }else{
            if (this.state.selected_channel === 'whatsapp'){
                this.sendWhatsappMessage()
                this.cleanShoppingList()
            }else if(this.state.selected_channel === 'email'){
                this.sendEmail()
            }
        }
    }

    cleanShoppingList = () =>{
        this.setState({selected_provider:null, shopping_list:[], open_modal_send: false, comments: ''})
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Lista de Compras | Inventarios - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/inventories'>Inventarios</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Lista de Compras</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Grid columns={3} stackable>
                    <Grid.Row>
                        <Grid.Column>
                            <Header as='h3'>Productos e Ingredientes con pocas unidades</Header>
                            <List divided verticalAlign='middle'>
                                {this.state.loading ? <Loading /> : this.state.data.length > 0 ? this.state.data.map(item => this.itemList(item)):<Message icon='bell' header='No hay productos o ingredientes con pocas unidades'/>}
                            </List>
                        </Grid.Column>
                        <Grid.Column>
                            <Header as='h3'>Mi lista de compras</Header>
                            <Form onSubmit={this.handleSubmit} fluid='true'>
                                <Form.Dropdown
                                    options={this.state.options}
                                    placeholder='Buscar'
                                    onSearchChange={this.handleSearchItem}
                                    onChange={(e, {value}) => this.handleSearchChange(value)}
                                    search
                                    selection
                                />
                            </Form>
                            <List divided verticalAlign='middle'>
                                {this.state.shopping_list.length > 0 ? this.state.shopping_list.map(item => this.itemShoppingList(item)):<Message icon='bell' header='Agrega algunas cosas a tu lista de compras'/>}
                            </List>
                        </Grid.Column>
                        <Grid.Column>
                            <Form>
                                <Header as='h3'>Comentarios</Header>
                                <Form.TextArea placeholder='Escribe aquí algunos comentarios...' rows={5} value={this.state.comments} onChange={this.handleCommentsChange}/>
                                <Button primary icon='send' fluid labelPosition='left' onClick={() => this.openModalSend('whatsapp')} content='Enviar' />
                            </Form>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Modal size='tiny' open={this.state.open_modal_send} onClose={() => this.setState({ open_modal_send: false })}>
                    <Modal.Header>Enviar lista de compras</Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Select label='Enviar por'
                                         options={C.SEND_CHANNELS}
                                         value={this.state.selected_channel}
                                         onChange={(e, {value}) => this.setState({selected_channel:value})} />
                            <Form.Select label='Contácto' search allowAdditions
                                         additionLabel={<i style={{color: '#e44745'}}>Nuevo Contácto: </i>}
                                         options={this.state.providers}
                                         lazyLoad={true}
                                         onAddItem={this.handleAddProvider}
                                         value={this.state.selected_provider ? this.state.selected_provider.id : null}
                                         onSearchChange={this.handleSearchProvider}
                                         onChange={(e, {value}) => this.handleProviderChange(value)}
                                         placeholder='Contácto'/>

                            {this.state.selected_provider ?
                                <List divided verticalAlign='middle'>
                                    <List.Item>
                                        <List.Content floated='right'>
                                            <Button icon='edit' onClick={() => this.editProvider()}/>
                                        </List.Content>
                                        <List.Content>
                                            <List.Description>
                                                <p style={{marginBottom:'3px'}}>
                                                    <strong>Email: </strong>{this.state.selected_provider.email}
                                                </p>
                                                <strong>Tél: </strong>{this.state.selected_provider.phone ? this.state.selected_provider.phone_prefix:''}{this.state.selected_provider.phone}
                                            </List.Description>
                                        </List.Content>
                                    </List.Item>
                                </List>:null}
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => this.setState({ open_modal_send: false })}>Cancelar</Button>
                        <Button primary onClick={() => this.handleSendMessage()}  loading={this.state.sending} disabled={this.state.sending}>Enviar</Button>
                    </Modal.Actions>
                </Modal>
                <ProviderDialog />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        provider_select: state.get('provider_select'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(data) {
            dispatch(showToast(data));
        },
        providerDialog(data) {
            dispatch(providerDialog(data))
        },
        selectProvider(data) {
            dispatch(selectProvider(data))
        },
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ShoppingList))



// WEBPACK FOOTER //
// ./src/containers/inventories/ShoppingList.js